/**
 * F-02: tenant-fuel app の route 定数。
 *
 * 現状は燃料油価格管理ページ 1 つだけだが、将来追加（履歴一覧詳細 / レポート 等）に備えて集約。
 */
export const ROUTES = {
  home: '/',
  fuelPrices: '/',
  signIn: '/signin',
  /** F-16: 設定（一覧表の区分 / 派生価格の値引き幅） */
  settings: '/settings',
  /** F-11: 店頭掲示用ポスター（A4 縦） */
  dwPrice: '/dw-price',
  /** F-11: 価格一覧表（A4 縦） */
  priceList: '/price-list',
} as const;
